import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { AuthLayout, Field, inputCls, primaryBtn, ErrorText } from "@/components/AuthLayout";
import { usePrefs } from "@/context/PrefsContext";
import { api, errMsg } from "@/lib/api";

export default function ResetPassword() {
  const { t } = usePrefs();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const request = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      if (data.reset_token) { setToken(data.reset_token); toast.success(t("resetInfo")); } else setErr("Email tidak ditemukan");
    } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };

  const reset = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success(t("saved")); nav("/login");
    } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };

  return (
    <AuthLayout title={t("resetTitle")} footer={<Link data-testid="reset-back-login" to="/login" className="underline-offset-4 hover:underline">{t("login")}</Link>}>
      {!token ? (
        <form onSubmit={request} className="space-y-4" data-testid="forgot-form">
          <Field label={t("email")} id="email"><input id="email" data-testid="forgot-email-input" type="email" required className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} /></Field>
          <ErrorText msg={err} id="forgot-error" />
          <button data-testid="forgot-submit-button" disabled={busy} className={primaryBtn}>{t("resetSend")}</button>
        </form>
      ) : (
        <form onSubmit={reset} className="space-y-4" data-testid="reset-form">
          <p data-testid="reset-info" className="rounded-lg bg-sage-soft px-3 py-2 text-sm">{t("resetInfo")}</p>
          <Field label={t("newPassword")} id="np"><input id="np" data-testid="reset-password-input" type="password" required minLength={6} className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} /></Field>
          <ErrorText msg={err} id="reset-error" />
          <button data-testid="reset-submit-button" disabled={busy} className={primaryBtn}>{t("resetDo")}</button>
        </form>
      )}
    </AuthLayout>
  );
}
